import { useAppDispatch } from "@store";
import { setDialogId } from "@store/global-slice";
import { useState } from "react";
import { useAuthStoreShallow } from "@/features/authentication";
import { Floating, Icon } from "@/shared";

export const InviteUser = ({
                             search,
                           }: {
  search: { value: string; hasOptions: boolean };
}) => {
  const [, setIsOpen] = useState(true);
  if (!search.value && !search.hasOptions) return null;

  return (
    <Floating
      isOpen={true}
      setIsOpen={setIsOpen}
      trigger={<></>}
      placement="bottom-start"
    >
      {search.hasOptions ? <Note /> : <Invite search={search.value} />}
    </Floating>
  );
};

const Note = () => {
  return (
    <div
      className="tw-mt-[2px] tw-flex tw-h-[26px] tw-w-[400px] tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-base tw-px-3 tw-font-sans tw-text-[11px]/tight tw-font-semibold tw-text-white">
      Some users may not appear due to their permissions.
    </div>
  );
};

const Invite = ({ search }: { search: string }) => {
  const dispatch = useAppDispatch();
  const isAdmin = useAuthStoreShallow((s) => s.isAdminOrAdministrator);
  if (!isAdmin) return null;
  return (
    <div
      className="tw-flex tw-w-[400px] tw-cursor-pointer tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-px-1 tw-py-2 tw-shadow-comment-popover"
      onClick={() => {
        dispatch(setDialogId({ id: "HAvid34jxn7BBvDdz6Bwh" }));
      }}
    >
      <div className="tw-group/button tw-flex tw-w-full tw-items-center tw-justify-between tw-px-[6px] tw-py-[7px]">
        <span className="tw-flex tw-items-center tw-font-sans tw-text-sm tw-font-normal tw-text-blue-base">
          No people found for{" "}
          <span
            className="tw-mx-[0.5ch] tw-inline-block tw-max-w-[100px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-font-semibold">
            {search}
          </span>
        </span>
        <div className="tw-ml-4 tw-flex tw-items-center tw-font-sans tw-text-sm tw-font-semibold tw-text-primary-base">
          Invite user
          <Icon
            icon="ri-arrow-right-line"
            color="#610CFF"
            size={20}
            className="tw-ml-1 tw-transition-transform tw-duration-150 group-hover/button:tw-translate-x-1"
          />
        </div>
      </div>
    </div>
  );
};
